import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveIdentityProviderRequestFailure({ uuid }) {
      const req = getState().find(
        ({ identityProvider }) => identityProvider.uuid === uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isRemoveIdentityProviderRequestPending({ uuid }) {
      const req = getState().find(
        ({ identityProvider }) => identityProvider.uuid === uuid,
      );

      return req ? req.request.isPending : false;
    },
    isRemoveIdentityProviderRequestSuccess({ uuid }) {
      const req = getState().find(
        ({ identityProvider }) => identityProvider.uuid === uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
